import { gql } from '@apollo/client';
import { ecommerceResult } from './query';

export const payloadAutoLabelQuery = `
  $projectId: Id!,
  $objectList: [Id!]!,
  $name: String!,
  $description: String,
  $start: Timestamp!,
  $labelList: [Id!]!,
  $keywords: [String!],
  $productOriginalIds: [String!]
`;

export const payloadAutoLabel = `
  projectId: $projectId,
  objectList: $objectList,
  name: $name,
  description: $description,
  start: $start,
  labelList: $labelList,
  keywords: $keywords,
  productOriginalIds: $productOriginalIds
`;

export const ECOMMERCE_ADD_COMPARISON = gql`
  mutation EcommerceComparison_addComparison(
    $projectId: Id!
    $comparisonName: String!
    $comparisonGroups: [ComparisonGroupInput!]!
    $sourceType: SourceType!
  ) {
    ecommerceComparison_addComparison(
      projectId: $projectId
      comparisonName: $comparisonName
      comparisonGroups: $comparisonGroups
      sourceType: $sourceType
    ) {
      id
      namespace
      displayName
      createdAt
      groups {
        id
        name
        color
        displayName
        createdAt
        objectGroup {
          id
          name
          displayName
          createdAt
          objectList {
            id
            socialMedia
            streamType
            content
            extraContent
            objectName
            isHashtag
            createdAt
            openApiId
            displayPicture
            includes
            excludes
            languages
            isEntity
            entityName
            isAuthorizeTiktok
          }
        }
        objectList {
          id
          socialMedia
          streamType
          content
          extraContent
          objectName
          isHashtag
          createdAt
          openApiId
          displayPicture
          includes
          excludes
          languages
        }
        labelList {
          id
          name
          displayName
          colorType
          isActive
          createdAt
        }
      }
      colors
    }
  }
`;

export const ECOMMERCE_EDIT_COMPARISON = gql`
  mutation ecommerceComparison_editComparison(
    $comparisonId: Id!
    $comparisonName: String!
    $comparisonGroups: [ComparisonGroupInput!]!
  ) {
    ecommerceComparison_editComparison(
      comparisonId: $comparisonId
      comparisonName: $comparisonName
      comparisonGroups: $comparisonGroups
    ) {
      id
      namespace
      displayName
      createdAt
      groups {
        id
        name
        color
        displayName
        createdAt
        objectGroup {
          id
          name
          displayName
          createdAt
          objectList {
            id
            socialMedia
            streamType
            content
            extraContent
            objectName
            isHashtag
            createdAt
            openApiId
            displayPicture
            includes
            excludes
            languages
            isEntity
            entityName
            isAuthorizeTiktok
          }
        }
        objectList {
          id
          socialMedia
          streamType
          content
          extraContent
          objectName
          isHashtag
          createdAt
          openApiId
          displayPicture
          includes
          excludes
          languages
        }
        labelList {
          id
          name
          displayName
          colorType
          isActive
          createdAt
        }
      }
      colors
    }
  }
`;

export const MANAGE_VISIBILITY_ON_ECOMMERE_STREAM = gql`
  mutation ecommerce_manageVisibilityOnStreams(
    $projectId: Id!
    $objectAndStream: [ObjectAndStreamListInput!]!
    $visibility: Visibility!
  ) {
    ecommerce_manageVisibilityOnStreams(
      projectId: $projectId
      objectAndStream: $objectAndStream
      visibility: $visibility
    ) {
      ${ecommerceResult}
    }
  }
`;

export const ECOMMERCE_ADD_GROUP_PRODUCT = gql`
  mutation ecommerceProductManagement_addGroupProduct(
    $projectId: Id!
    $name: String!
    $parentId: Id
  ) {
    ecommerceProductManagement_addGroupProduct(
      projectId: $projectId
      name: $name
      parentId: $parentId
    ) {
      id
      name
      createdAt
    }
  }
`;

export const ECOMMERCE_UPDATE_GROUP_PRODUCT = gql`
  mutation ecommerceProductManagement_updateGroupProduct(
    $id: Id!
    $name: String!
    $productIds: [Id!]
    $groupCategory: GroupCategoryEnum
  ) {
    ecommerceProductManagement_updateGroupProduct(
      id: $id
      name: $name
      productIds: $productIds
      groupCategory: $groupCategory
    ) {
      id
      name
      createdAt
    }
  }
`;

export const ECOMMERCE_DELETE_GROUP_PRODUCT = gql`
  mutation ecommerceProductManagement_deleteGroupProduct($id: Id!) {
    ecommerceProductManagement_deleteGroupProduct(id: $id) {
      id
      name
      createdAt
    }
  }
`;

export const ECOMMERCE_CREATE_AUTO_LABEL = gql`
  mutation ecommerceAutoLabel_createAutoLabel(${payloadAutoLabelQuery}) {
    ecommerceAutoLabel_createAutoLabel(${payloadAutoLabel}) {
      id
      projectId
      objectList{
        id
        socialMedia
        streamType
        content
        extraContent
        objectName
        isHashtag
        createdAt
        openApiId
        displayPicture
      }
      name
      description
      start
      labelList{
        id
        name
        displayName
        colorType
        isActive
        createdAt
      }
      keywords
      postOwnerships
      isActive
      createdAt
      productList {
        id
        name
        originalId
        platform
        link
        image
      }
    }
  }
`;

export const ECOMMERCE_EDIT_AUTO_LABEL = gql`
  mutation ecommerceAutoLabel_editAutoLabel($autoLabelId: Id!, ${payloadAutoLabelQuery}) {
    ecommerceAutoLabel_editAutoLabel(autoLabelId: $autoLabelId, ${payloadAutoLabel}) {
      id
      projectId
      objectList{
        id
        socialMedia
        streamType
        content
        extraContent
        objectName
        isHashtag
        createdAt
        openApiId
        displayPicture
      }
      name
      description
      start
      labelList{
        id
        name
        displayName
        colorType
        isActive
        createdAt
      }
      keywords
      postOwnerships
      isActive
      createdAt
      productList {
        id
        name
        originalId
        platform
        link
        image
      }
    }
  }
`;

export const ECOMMERCE_DELETE_AUTO_LABEL = gql`
  mutation ecommerceAutoLabel_deleteAutoLabel($autoLabelId: Id!) {
    ecommerceAutoLabel_deleteAutoLabel(autoLabelId: $autoLabelId) {
      id
      projectId
      objectList {
        id
        socialMedia
        streamType
        content
        extraContent
        objectName
        isHashtag
        createdAt
        openApiId
        displayPicture
      }
      name
      description
      start
      labelList {
        id
        name
        displayName
        colorType
        isActive
        createdAt
      }
      keywords
      postOwnerships
      isActive
      createdAt
      productList {
        id
        name
        originalId
        platform
        link
        image
      }
    }
  }
`;
